/*
 * This file is part of litalino/template.
 *
 * Copyright (c) 2023 Litalino.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */
import app from 'flarum/forum/app';
import {extend} from 'flarum/common/extend';
import ItemList from 'flarum/common/utils/ItemList';
//import IndexPage from 'flarum/forum/components/IndexPage';
import { slug } from '../common';
import HomePage from './components/HomePage';
//import customizeIndexPage from './customizeIndexPage';
import customizeBlogItem from './customizeBlogItem';
import TagNavigation from './components/TagNavigation';
import CustomWelcomeHero from './customWelcomeHero';
import HomeFeatured from './components/HomeFeatured';
import HomeBlog from './components/HomeBlog';
//import addFooter from './components/Footer/addFooter';
//import CustomFooter from './customFooter';
import apiDocument from './apiDocument';
//import addNoAnswerFilter from './addNoAnswerFilter';
//import GlobalStats from '../common/models/GlobalStats';
//import Alert from 'flarum/common/components/Alert';
//import Button from 'flarum/components/Button';
//import HomeKnowledgebase from './components/HomeKnowledgebase';
//import VerifyEmail from './components/VerifyEmail';
import HomeWelcomeContainer from './components/HomeWelcomeContainer';

// Add about pages
import AboutPage from './pages/About/AboutPage';
import TeamPage from './pages/About/TeamPage';
import HistoryPage from './pages/About/HistoryPage';
import PartnersPage from './pages/About/PartnersPage';
//import EnglishCampaign from './pages/Campaigns/EnglishCampaign';

//Daily-check-in
//import Button from 'flarum/components/Button';
import Alert from 'flarum/common/components/Alert';
//import checkInSuccessModal from 'flarum/ziiven/daily-check-in/components/checkInSuccessModal';
//import checkInFailedModal from 'flarum/ziiven/daily-check-in/components/checkInFailedModal';
import checkInSuccessModal from './checkInSuccessModal';
import checkInFailedModal from './checkInFailedModal';

// Override pages tag
//import DiscussionsOverviewPage from './pages/DiscussionsOverviewPage';

app.initializers.add('litalino/flarum-template', function (app) {

	 // Add about pages
	 app.routes.about = { path: '/over', component: AboutPage };
	 app.routes.team = { path: '/over/team', component: TeamPage };
	 app.routes.history = { path: '/over/history', component: HistoryPage };
	 app.routes.partners = { path: '/over/partners', component: PartnersPage };
	 //app.routes.campaignEnglish = { path: '/devnl/dutch-developers-platform', component: EnglishCampaign };

	if (app.initializers.has('litalino/flarum-ext-guestengagement')) {
		//console.log('flarum-ext-guestengagement');
		extend(HomePage.prototype, 'view', function (vdom) {
			if (!app.session.user)
			if (app.forum.attribute('justoverclock-guestengagement.hideHomeBox') === true)
				if (vdom.children && vdom.children.splice) {
				    /*  Imposta un timeout per far scomparire automaticamente il div*/
					setTimeout(function () {
						$('#wrapperengage').fadeOut().empty();
					}, app.forum.attribute('justoverclock-guestengagement.timeOut'));
			
					const insert = m(
						'div',
						{ id: 'wrapperengage' },
						m('div', { class: 'engagebox' }, [
						m('p', [
							m('strong', app.translator.trans('flarum-ext-guestengagement.forum.hello')),
							m('p'),
							app.translator.trans('flarum-ext-guestengagement.forum.whenucreate'),
							app.translator.trans('flarum-ext-guestengagement.forum.uwillreceive'),
						]),
						//app.forum.attribute('justoverclock-guestengagement.hidePostButtom') === true ? '' : buttom_tag_home
						//if (app.forum.attribute('justoverclock-guestengagement.hideHomeboxButtom') === true)
							/*m(
							'button',
							{ className: '.SplitDropdown-button Button Button--primary hasIcon', type: 'button', onclick: () => app.modal.show(SignUpModal) },
							app.translator.trans('core.forum.header.sign_up_link')
							),
							m(
							'i',
							app.translator.trans('flarum-ext-guestengagement.forum.or')
							),
							m(
							'button',
							{ className: '.SplitDropdown-button Button Button--primary hasIcon', type: 'button', onclick: () => app.modal.show(LogInModal) },
							app.translator.trans('core.forum.header.log_in_link')
							),*/
						//}
						])
					);
					vdom.children.splice(1, 0, insert);
				}
		});

	}

	if (app.initializers.has('ziven-checkin')) {
		//console.log('flarum-daily-check-in');
		//app.alerts.show(Alert, { type: 'success' }, 'checkInSuccessRewardText');
		extend(HomePage.prototype, 'oninit', function() {
			//console.log('flarum-daily-check-in');
			
			if (app.session.user !== null && app.forum.attribute('allowCheckIn') === true) {
			  //const routeName = app.current.get('routeName');
		     
			  const totalContinuousCheckIn = app.session.user.attribute("totalContinuousCheckIn");
			  const canCheckin = app.session.user.attribute("canCheckin");
			  //console.log(canCheckin);
			  const canCheckinContinuous = app.session.user.attribute("canCheckinContinuous");
			  const serverData = app.session.user.attribute("serverDate");
			  const forumCheckinSuccessPromptType = app.forum.attribute("forumCheckinSuccessPromptType");
			  //console.log('forumCheckinSuccessPromptType: '+ forumCheckinSuccessPromptType); //1
			  let checkInCompatibleExtensions = app.session.user.attribute("checkInCompatibleExtensions");
			  //console.log('checkInCompatibleExtensions: '+ forumCheckinSuccessPromptType);//1
			  let lastCheckinTime = app.session.user.attribute("lastCheckinTime");
			  //console.log('lastCheckinTime: '+ forumCheckinSuccessPromptType);//1
			  //let checkinButtonText;
			  //let itemName = "forum-checkin";

			  if (canCheckin === true) {

				//checkinButtonText = app.translator.trans('ziven-checkin.forum.check-in');
				//const checkinButtonText = app.translator.trans('ziven-checkin.forum.check-in'); //Đăng ký vào
				//console.log('checkinButtonText: '+ checkinButtonText);

				app.session.user.save({canCheckin:false,totalContinuousCheckIn:canCheckinContinuous===true?totalContinuousCheckIn+1:1}).then(() => {
					const forumCheckinSuccessPromptText = app.forum.attribute("forumCheckinSuccessPromptText");
					//console.log('forumCheckinSuccessPromptText: '+ forumCheckinSuccessPromptText);
					const forumCheckinSuccessPromptRewardText = app.forum.attribute("forumCheckinSuccessPromptRewardText");
					//console.log('forumCheckinSuccessPromptRewardText: '+ forumCheckinSuccessPromptRewardText);
					const canCheckinRecheck = app.session.user.attribute("canCheckin");
					//console.log('canCheckinRecheck: '+ canCheckinRecheck);

					if (forumCheckinSuccessPromptText !== "" || forumCheckinSuccessPromptRewardText !== "") {
						if (forumCheckinSuccessPromptType === 1) {
							if (canCheckinRecheck === false) {
								const forumCheckinRewarMoney = app.forum.attribute("forumCheckinRewarMoney");
								//console.log('forumCheckinRewarMoney: '+ forumCheckinRewarMoney);
								const moneyExtensionExist = app.forum.attribute('antoinefr-money.moneyname') !== undefined;
								//console.log('moneyExtensionExist: '+ moneyExtensionExist);

								let moneyName = "";
								let rewardText = "";

								if (forumCheckinSuccessPromptText !=="") {
									const checkInSuccessText = forumCheckinSuccessPromptText.replace('[days]', app.session.user.attribute("totalContinuousCheckIn"));
									const successTextAlertKey = app.alerts.show(Alert, { type: 'success' }, checkInSuccessText);
									//console.log('alert-forumCheckinSuccessPromptText: '+ successTextAlertKey);
								}

								if (moneyExtensionExist === true && forumCheckinSuccessPromptRewardText !== "") {
									moneyName = app.forum.attribute('antoinefr-money.moneyname') || '[money]';
									rewardText = moneyName.replace('[money]', forumCheckinRewarMoney);

									const checkInSuccessRewardText = forumCheckinSuccessPromptRewardText.replace('[reward]', rewardText);
									const successRewardTextAlertKey = app.alerts.show(Alert, { type: 'success' }, checkInSuccessRewardText);
									//console.log('alert-moneyExtensionExist: '+ successRewardTextAlertKey);
								}
							} else {
								const failedTextAlertKey = app.alerts.show(Alert, { type: 'error' }, app.translator.trans('ziven-checkin.forum.check-in-failed')+" "+app.translator.trans('ziven-checkin.forum.try-again-later'));
								//console.log('failedTextAlertKey: '+ failedTextAlertKey);
								//app.alerts.show(Alert, { type: 'error' }, app.translator.trans('ziven-checkin.forum.check-in-failed')+" "+app.translator.trans('ziven-checkin.forum.try-again-later'));
							}
						} else if (forumCheckinSuccessPromptType === 2) {
							//console.log('forumCheckinSuccessPromptType: '+ forumCheckinSuccessPromptType);
							//console.log('canCheckinRecheck: '+ canCheckinRecheck);
							if (canCheckinRecheck === false) {
								app.modal.show(checkInSuccessModal);
								//console.log('checkInSuccessModal: '+ checkInSuccessModal);
							} else {
								app.modal.show(checkInFailedModal);
								//console.log('checkInFailedModal: '+ checkInFailedModal);
							}
						}
					}
			
					/*const forumAutoCheckIn = app.forum.attribute("forumAutoCheckin");
					const forumAutoCheckInDelay = app.forum.attribute("forumAutoCheckinDelay");
			
					if (forumAutoCheckIn === 1) {
						setTimeout(function() {
							$("#checkInButton").click();
						},forumAutoCheckInDelay);
					}*/
				});

			  }

			}
			
		});
	}

	//DiscussionsOverviewPage();

	if (app.initializers.has('litalino/flarum-country-flags')) {
		/*
		override(WelcomeHero.prototype, 'view', function (original) {
			if (app.session.user && app.session.user.isEmailConfirmed()) {
			if (app.session.user.data.attributes.countryCode != null && app.session.user.data.attributes.countryCode != '') {
				return original();
			}
			if (app.forum.attribute('justoverclock-country-flags.setCountryBindLogin') === true) {
				return m("div.Alert", [
				m("div.container", [
					m("span.alert-danger", app.translator.trans('justoverclock-country-flags.forum.binding_country')),
					m("a.bind.Button--primary[href='/settings']", app.translator.trans('justoverclock-country-flags.forum.binding_country_click'))
				])
				]);
			}
			}
			return original();
		});
		*/
	}

});

app.initializers.add(slug, () => {
	//app.routes.__loading = { path: '/__loading', component: LoadingPage };

    // Add new homepage
	app.routes.home = { path: '/home', component: HomePage };

	apiDocument();
	//addNoAnswerFilter();
	//customizeIndexPage();
	//CustomWelcomeHero();
	customizeBlogItem();

	extend(HomePage.prototype, 'view', function (vdom) {
		/*
			* Unshift is used to simplify the design of below elements,
			* which take up the whole width of the screen. The order below
			* corresponds to the inverse order as it's displayed to the
			* user in the frontend. I.e. <WelcomeHeroConent/> will be
			* displayed at the very top of the page.
			*/
		vdom.children.unshift(<TagNavigation />);
		vdom.children.unshift(<CustomWelcomeHero />);
		//vdom.children.unshift(<HomePage />);
		//{app.session.user && !app.session.user.attribute('isEmailConfirmed') && <VerifyEmail />}
		/*if (app.session.user && !app.session.user.attribute('isEmailConfirmed') ) {
			vdom.children.unshift(<VerifyEmail />);

		}*/
		vdom.children.unshift(<HomeWelcomeContainer />);

	});

	extend(HomePage.prototype, 'blockGroups', function (groups) {
		//groups.remove('welcome');
		//groups.remove('hero');
		//groups.remove('tags');

		if (app.initializers.has('fof/frontpage')) {
			const key = 'featured';
			groups.add(
				key,
				new ItemList().add(key, <HomeFeatured params={{ key }} preloadedKey={key} />),
				80,
			);
		}
		
		if (app.initializers.has('v17development-flarum-blog')) {
			const key = 'blog';
			groups.add(
				key,
				new ItemList().add(key, <HomeBlog params={{}} preloadedKey={key} />),
				75,
			);
		}

		if (app.initializers.has('flarum-tags')) { //&& app.forum.attribute('canViewKb')
			//console.log('flarum-tags');
			/*const key = 'tags';
			groups.add(
				key,
				new ItemList().add(key, <HomeKnowledgebase params={{}} preloadedKey={key} />),
				71,
			);*/
		}
		
	});

	//app.store.models.global_stats = GlobalStats;

	//addFooter();
	
});

// Expose compat API
//import coreCompat from './compat';
import { compat } from '@flarum/core/forum';

//Object.assign(compat, coreCompat);
Object.assign(compat);